module.exports = __webpack_public_path__ + "img/preview.25a54440.svg";